import "styled-components";

import { theme as bosonTheme } from "@bosonprotocol/react-kit";

const theme = {
  ...bosonTheme
};

export default theme;
